import React from 'react'

const SvgInstagram = props => (
    <svg viewBox="0 0 44 44" {...props}>
        <style />
        <g id="Small_icons__x28_selected_x29_">
            <path
                d="M22 26c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-26C9.8 0 0 9.8 0 22s9.8 22 22 22 22-9.8 22-22S34.2 0 22 0zm12 31c0 1.7-1.3 3-3 3H13c-1.7 0-3-1.3-3-3V13c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v18zm-5-9c0 3.9-3.1 7-7 7s-7-3.1-7-7c0-.7.1-1.4.3-2H13v11h18V20h-2.3c.2.6.3 1.3.3 2zm1-9h-2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1z"
                id="_x31_268-instagram_x40_2x.png_8_"
            />
        </g>
    </svg>
)

export default SvgInstagram



// WEBPACK FOOTER //
// ./src/ui/icons/Instagram.js